import { useEffect, useState } from "react";
import { useAxios } from "../../utils/useAxios";
import FormBuildTabs from "../formBuilder/FormBuildTabs";
import DataTableTabs from "../dataTable/dataTableTabs";
import { Button } from "@mui/material";
import FormLoading from "../../Loaders/formLoading";
import InfoModal from "../components/Info/InfoModal";
import { useModal } from "../../hooks/useModal";
import { Modal } from "../../components/ui/modal";
import styled from "styled-components";
import LoadSideBarform from "../../components/Load/LoadSideBarform";
import LoadCount from "../../components/Load/LoadCount";

interface props {
  tabsDetails: any;
  source?: any;
  formAction?: any;
}

const FormSplite = ({ tabsDetails, source, formAction }: props) => {
  const [changeSplite, setChangeSplite] = useState(false);
  const { isOpen, openModal, closeModal } = useModal();
  const [crudOp, setCrudOP] = useState({});
  const { res, mutate, isPending } = useAxios({
    url: "/api/auth/form",
  });

  let { formid, list, title } = tabsDetails;

  // Fetch initial form on mount
  useEffect(() => {
    if (formid) {
      setChangeSplite(false);
      mutate({ formId: formid });
    }
  }, [formid]);

  const openlist = () => {
    setChangeSplite(false);
  };

  const crud = (event: any) => {
    openModal();
    setCrudOP(event);
  };

  if (isPending) {
    return <FormLoading />;
  }

  return (
    <>
      {list === 0 || changeSplite ? (
        <div>
          {source && formid === "load" ? (
            <div>
              <LoadCount />
              <div className="grid grid-cols-2 gap-2">
                <Div>
                  <FormBuildTabs
                    getformData={res?.data?.data}
                    source={source}
                    openlist={openlist}
                  />
                </Div>
                <div>
                  <LoadSideBarform
                    source={source}
                    getformData={res?.data?.data}
                  />
                </div>
              </div>
            </div>
          ) : (
            <FormBuildTabs
              getformData={res?.data?.data}
              source={source}
              openlist={openlist}
              formAction={formAction}
            />
          )}
        </div>
      ) : (
        <>
          <Button
            variant="contained"
            color="error"
            sx={{ mb: 2, boxShadow: "none" }}
            onClick={() => setChangeSplite(true)}
            size="small"
          >
            Add {title}
          </Button>
          <DataTableTabs formId={formid} source={source} crud={crud} />
        </>
      )}
      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        className="max-w-[1000px] m-4"
        header={"Information"}
      >
        <div className="no-scrollbar relative w-full max-w-[1000px] overflow-y-auto rounded-3xl bg-white p-4 dark:bg-gray-900 lg:p-11">
          <FormBuildTabs
            getformData={res?.data?.data}
            openlist={openlist}
            crudOp={crudOp}
          />
        </div>
      </Modal>
    </>
  );
};

export default FormSplite;

const Div = styled("div")`
  .col-1 {
    width: 16.66666667% !important;
  }
  .row .row .col-2,
  .row .row .col-3 {
    width: 33.33333333% !important;
  }
`;
